import { DetailsPanel, SpeedChip } from '@/components/controls';
import { useOptionLookup } from '@/hooks';
import { useDallasKeys } from '@/utils/config';
import { Box, Stack, Typography } from '@mui/material';
import { blue } from '@mui/material/colors';
import { format } from 'date-fns';
import { Popup } from 'react-map-gl/maplibre';
import { VehicleEquipmentIcons } from '../VehicleEquipmentIcons';
import { Status } from './Status';

function DriverDetailsPanel({ driver, isLastDriver = false }) {
  if (!driver?.code) return null;

  return (
    <DetailsPanel
      title={isLastDriver ? 'Last Driver' : 'Driver'}
      entries={[
        {
          label: 'Name',
          value: [driver.forenames, driver.surname]
            .filter(Boolean)
            .join(' ')
            .trim(),
        },
        { label: 'Staff #', value: driver.code },
        { label: 'Role', value: driver.role },
      ]}
      rightHeader={
        driver.collarNumber && (
          <Box
            sx={{
              fontSize: 10,
              color: 'white',
              bgcolor: blue[900],
              borderRadius: 1,
              px: 0.5,
              my: 0.25,
            }}
          >
            {driver.collarNumber}
          </Box>
        )
      }
    />
  );
}

export function ExternalVehiclePopup({
  hoverInfo: {
    longitude,
    latitude,
    feature: { properties },
  },
}) {
  const vehicleRoles = useOptionLookup('vehicleRole');

  return (
    <Popup
      longitude={longitude}
      latitude={latitude}
      offset={16}
      closeButton={false}
    >
      <Stack spacing={0.5}>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
          {properties.registrationNumber}
        </Typography>
        <Typography variant="caption" color="textSecondary">
          {format(new Date(properties.time), 'dd/MM HH:mm:ss')}
        </Typography>
        <Status status={properties.status} />
        <DetailsPanel
          entries={[
            { label: 'External Vehicle' },
            { label: 'Fleet #', value: properties.fleetNumber },
            {
              label: 'Role',
              value: vehicleRoles[properties.role] ?? properties.role,
            },
          ]}
        />
        <Stack
          spacing={1}
          direction="row"
          sx={{ justifyContent: 'space-between', pt: 0.5 }}
        >
          <SpeedChip
            speedKilometresPerHour={properties.speedKilometresPerHour}
            speedLimitKilometresPerHour={
              properties.reverseGeocode?.speedLimitKilometresPerHour
            }
          />
          <VehicleEquipmentIcons properties={properties} />
        </Stack>
      </Stack>
    </Popup>
  );
}
